import { ref, watch } from 'vue'
import client from '@/composables/homebaseClient'

export default function useHomebaseSignups(initialParams = {}) {
    const items = ref([])
    const loading = ref(false)
    const error = ref(null)
    const total = ref(null)

    const params = ref({
        // 'any' means don't send status filter
        status: 'any',
        community: '',
        search: '',
        limit: 100,
        sortBy: 'createdAt',
        sortDir: 'desc',
        ...initialParams
    })

    const toQuery = () => {
        const q = new URLSearchParams()
        if (params.value.status && params.value.status !== 'any') q.set('status', params.value.status)
        if (params.value.community) q.set('community', params.value.community)
        if (params.value.limit) q.set('limit', String(params.value.limit))
        if (params.value.sortBy) q.set('sortBy', params.value.sortBy)
        if (params.value.sortDir) q.set('sortDir', params.value.sortDir)
        // search/date filters are client-side for now
        return q.toString() ? `?${q.toString()}` : ''
    }

    const fetchSignups = async () => {
        loading.value = true
        error.value = null
        try {
            const res = await client.get(`/signups${toQuery()}`)
            const list = Array.isArray(res.data) ? res.data : res.data?.items || []
            items.value = list
            total.value = res.data?.total ?? list.length
        } catch (err) {
            error.value = err.detail || 'Failed to load signups'
        } finally {
            loading.value = false
        }
    }

    watch(params, fetchSignups, { deep: true })

    return { items, loading, error, total, params, fetchSignups }
}


